/* tslint:disable */

/**
 */
export class CreateModiPipeLine {
    PRESSURE?: number;
    ID_STUDY?: number;
    ELBOWS?: number;
    HEIGHT?: number;
    INSUL_VALVES?: number;
    INSULLINE_LENGHT?: number;
    NOINSUL_VALVES?: number;
    NOINSULLINE_LENGHT?: number;
    ELBOWSVALUE?: number;
    TEESVALUE?: number;
    TEES?: number;
    INSULATED_LINE?: number;
    INSULATED_VALVES?: number;
    NON_INSULATED_LINE?: number;
    NON_INSULATED_VALVES?: number;
    STORAGE_TANK?: number;
    GAS_TEMP?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/create-modi-pipe-line.ts